import { Dispatch, SetStateAction, useId } from 'react';
import {
  TeamWidgetContainer,
  TeamWidgetTitle,
  TeamsWidgetHeader,
  TeamWidgetListFooter,
} from './styles/TeamsWidget.styled';
import { TeamWidgetAutocomplete } from './TeamWidgetAutocomplete';
import { ColorCodedEmployee, TeamWidgetSection } from './TeamWidgetSection';
import { Employee } from 'src/tabs/hooks/useGetAllUsers';
import { EyeOff20Filled, Eye20Filled } from '@fluentui/react-icons';
import { appearance } from 'src/hooks/useAlertMessage';
import { analyticsEventSend } from 'src/utils/analytics/analyticsEventSend';

interface TeamWidgetProps {
  setShowMessage: (message: string, appearance: appearance) => void;
  users: Array<Employee>;
  setTeam: Dispatch<SetStateAction<Array<ColorCodedEmployee>>>;
  team: Array<ColorCodedEmployee>;
  hideEmployeeHandler: () => void;
  hideEmployees: boolean;
  groups: { [k in string]: string };
  getGroupUsers: (groupId: string) => Promise<void>;
  groupUsersEmails: Array<string>;
}

export const TeamWidget = ({
  setShowMessage,
  users,
  setTeam,
  team,
  hideEmployeeHandler,
  hideEmployees,
  groups,
  getGroupUsers,
  groupUsersEmails,
}: TeamWidgetProps) => {
  const clearAllKey = `clearAll-${useId()}`;

  const handleReset = () => {
    setTeam([]);
  };

  const handleTeamWidgetTitleClick = () => {
    hideEmployeeHandler();
    analyticsEventSend('Hide/Show Employees', 'Hide/Show Employees - Button');
  };

  return (
    <TeamWidgetContainer>
      <TeamsWidgetHeader>
        <TeamWidgetTitle>
          Team
          <div onClick={handleTeamWidgetTitleClick}>
            {hideEmployees ? <EyeOff20Filled /> : <Eye20Filled />}
          </div>
        </TeamWidgetTitle>
        <TeamWidgetAutocomplete
          team={team}
          setTeam={setTeam}
          setShowMessage={setShowMessage}
          users={users}
          groups={groups}
          getGroupUsers={getGroupUsers}
          groupUsersEmails={groupUsersEmails}
        />
      </TeamsWidgetHeader>
      <TeamWidgetSection team={team} setTeam={setTeam} />
      {team.length > 3 && (
        <TeamWidgetListFooter key={clearAllKey}>
          <p onClick={handleReset}>Clear all</p>
        </TeamWidgetListFooter>
      )}
    </TeamWidgetContainer>
  );
};
